import { Controller } from "@hotwired/stimulus";
const QUESTION_TYPE_SELECT = "select[name$='[question_type]']";
const GROUPED_CHECKBOX = "input[type='checkbox'][name$='[grouped]']";
const CHECKBOX_WRAPPER = ".questionnaire-question-grouped";
const GROUPS_SECTION = ".questionnaire-question-groups";
const FLAT_LIST = "[data-extra-censuses-flat-list]";
const FLAT_ADD_BUTTON = ".add-response-option";
const MULTIPLE_OPTION = "multiple_option";
const TOGGLE_EVENT = "grouped-question-toggle:change";
export default class extends Controller {
  connect() {
    var _a, _b, _c;
    this.typeSelect = this.element.querySelector(QUESTION_TYPE_SELECT);
    this.checkbox = this.element.querySelector(GROUPED_CHECKBOX);
    if (!this.typeSelect || !this.checkbox) {
      return;
    }
    this.checkboxWrapper = this.checkbox.closest(CHECKBOX_WRAPPER);
    this.groupsSection = this.element.querySelector(GROUPS_SECTION);
    this.flatList = this.element.querySelector(FLAT_LIST);
    this.flatSection = (_a = this.flatList) == null ? void 0 : _a.parentElement;
    this.flatAddRow = (_c = (_b = this.flatSection) == null ? void 0 : _b.querySelector(FLAT_ADD_BUTTON)) == null ? void 0 : _c.closest(".row");
    this.previousGrouped = this.checkbox.checked;
    this.boundOnTypeChange = this.onTypeChange.bind(this);
    this.boundOnToggle = this.onToggle.bind(this);
    this.typeSelect.addEventListener("change", this.boundOnTypeChange);
    this.checkbox.addEventListener("change", this.boundOnToggle);
    this.syncCheckboxVisibility();
    this.syncSectionVisibility(this.previousGrouped);
  }
  disconnect() {
    var _a, _b;
    (_a = this.typeSelect) == null ? void 0 : _a.removeEventListener("change", this.boundOnTypeChange);
    (_b = this.checkbox) == null ? void 0 : _b.removeEventListener("change", this.boundOnToggle);
  }
  onTypeChange() {
    if (this.typeSelect.value !== MULTIPLE_OPTION && this.checkbox.checked) {
      this.checkbox.checked = false;
      this.onToggle();
    }
    this.syncCheckboxVisibility();
  }
  onToggle() {
    var _a;
    const grouped = this.checkbox.checked;
    const wasGrouped = this.previousGrouped;
    this.previousGrouped = grouped;
    this.syncSectionVisibility(grouped);
    (_a = this.groupsSection) == null ? void 0 : _a.dispatchEvent(new CustomEvent(TOGGLE_EVENT, { detail: { grouped, wasGrouped } }));
  }
  syncCheckboxVisibility() {
    var _a;
    (_a = this.checkboxWrapper) == null ? void 0 : _a.classList.toggle("hidden", this.typeSelect.value !== MULTIPLE_OPTION);
  }
  syncSectionVisibility(grouped) {
    var _a, _b, _c;
    (_a = this.groupsSection) == null ? void 0 : _a.classList.toggle("hidden", !grouped);
    (_b = this.flatSection) == null ? void 0 : _b.classList.toggle("hidden", grouped);
    (_c = this.flatAddRow) == null ? void 0 : _c.classList.toggle("hidden", grouped);
  }
}
